module.exports = __webpack_public_path__ + "static/img/tx1-b.853e0af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/tx1-b.png
// module id = Dz8s
// module chunks = 1